import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import * as fromStore from '../../lib';

export interface Data {
  data: unknown;
  id: string;
  route: string;
}

export interface State {
  id: { [uuid: string]: Data };
}

@Injectable({
  providedIn: 'root',
})
export class ComponentStoreLogger {
  constructor(public route: Router, public store: Store<fromStore.DashboardState>) {}

  // private getRoute(data) {
  //   for (const [key, value] of Object.entries(data)) {
  //     //   console.log('loop routes');
  //     //   console.log(key);
  //     return value['route'];
  //   }
  // }

  protected get getCurrentRoute() {
    return this.route.url.split('/app/')[1].split('/')[0];
  }

  protected updateGlobalStore(data: Data) {
    // const route = this.getRoute(data);

    // let obj = {};

    // for (const [key, value] of Object.entries(data)) {
    //   console.log('value');
    //   console.log(value);
    //   obj = {
    //     [route]: JSON.parse(JSON.stringify(value)),
    //   };
    // }

    // // const obj = {
    // //   [route]: JSON.parse(JSON.stringify(data)),
    // // };

    this.store.dispatch(new fromStore.Update_UI(JSON.parse(JSON.stringify(data))));
  }
}
